// @moods/ui copy for the profile tools (image crop editor). tr and en must have identical keys.
// Turkish part; profile.en.ts must have the same keys.
const dict: Record<string, string> = {
  'crop.frame': 'Görseli konumlandır',
  'crop.hint': 'Sürükleyerek ya da ok tuşlarıyla kaydır; + ve − ile yakınlaştır.',
  'crop.zoom': 'Yakınlaştırma',
  'crop.zoomIn': 'Yakınlaştır',
  'crop.zoomOut': 'Uzaklaştır',
};

export default dict;
